import React, { useEffect, useState, useCallback, useRef, useReducer } from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import agent from "../../agent";
import axios from "axios";

/** AI api를 사용해서 사용자가 입력한 문단을 분석하여 내용에 맞는 이미지를 생성합니다. */
const ImageDirectGeneratorBoard = inject("commonStore")(
  observer((props) => {
    const [isGeneratingImage, setIsGeneratingImage] = useState(false); // 이미지 생성 함수 동작시, 화면에 상태를 출력하기 위함 - image api용
    const [isGeneratingErrorMessage, setIsGeneratingErrorMessage] = useState(false); // 생성 에러가 난 경우 화면에 출력하기 위함
    const [inputValue, setInputValue] = useState(""); // 사용자 이미지 생성용 인풋값
    const [imageResponse, setImageResponse] = useState([]); // 이미지 생성기에서 리턴받은 값 저장
    const [translatedText, setTranslatedText] = useState(null);

    /** 사용자에게 입력값을 key i/o마다 받기 위한 함수 */
    const handleInputChange = (event) => {
      setInputValue(event.target.value);
    };

    /** stable diffusion api를 사용해서 이미지를 생성함 */
    const imageGenerator = (inputPrompt) => {
      if (inputPrompt.length === 0) {
        alert("입력된 내용이 없습니다.");
        return;
      }

      console.log(111, inputPrompt);

      agent.Python_API.googletrans({ text: inputPrompt })
        .then((res) => {
          console.log(222, res.result);
          const translatedText = res.result;
          console.log(333, res.result);
          setTranslatedText(res.result);

          agent.Python_API.stablediffusion({ prompt: translatedText })
            .then(async (res) => {
              console.log(444, res);
              setImageResponse(res); // 응답받은 값 저장
              setIsGeneratingErrorMessage(false); // 이미지 생성 성공 시 에러 메시지 표시 제거
              console.log(555);
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setIsGeneratingImage(false);
            });
        })
        .catch((err) => {
          console.log(222);

          console.log(err);
        });

      setIsGeneratingImage(true);
    };

    // 이미지 생성시, 응답 값이 없을 경우 자동으로 API를 다시 실행
    useEffect(() => {
      if (!isGeneratingImage && isGeneratingErrorMessage) {
        console.log(666);
        imageGenerator(inputValue);
        setIsGeneratingErrorMessage(true);
      }
    }, [imageResponse, inputValue, isGeneratingErrorMessage, isGeneratingImage]);

    /** 사용자의 컴퓨터에 이미지 저장하기 */
    const saveImageLocally = async (imageName) => {
      console.log(233333333);
      try {
        console.log(333333);
        // const response = await axios.get(`http://localhost:8020/image_stable_diffusion/${imageName}`, {
        const response = await axios.get(`https://okr.luvd.co.kr/api/common/image/${imageName}`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", imageName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error); // 저장 실패 시 에러 출력
      }
    };

    return (
      <>
        <ImageGeneratorContainer>
          <>
            <h1>이미지 수동 생성기</h1>
            <p>stable diffusion을 직접 사용할 수 있습니다.</p>
            <p>한글을 입력하면 영어로 자동 번역됩니다.</p>
            <br></br>
            <input className="direct_input_box" placeholder="이미지를 설명하는 문구를 자세히 입력해주세요." value={inputValue} onChange={handleInputChange} />
            <span className="image_generate_btn" onClick={() => imageGenerator(inputValue)}>
              이미지 생성하기
            </span>
            {isGeneratingImage ? <span> 이미지 생성 중..</span> : <></>}
            {isGeneratingErrorMessage && <span> 미생성 </span>}
            <p>{translatedText ? <span>translated prompt : {translatedText}</span> : <></>}</p>
            <Tuple>
              <div className="created_images_container">
                <span className="file_name">file name</span>
                <span className="index">index</span>
                <span className="preview">preivew</span>
                <span className="download">download</span>
              </div>
            </Tuple>
            {/* api에서 응답받은 이미지를 화면에 출력 */}
            {imageResponse && imageResponse.length !== 0 ? (
              imageResponse.image_response.map((item, index) => (
                <>
                  <Tuple>
                    <div className="created_images_container">
                      <span>{item.image_name}</span>
                      <span>{item.index}</span>
                      <span>{index}</span>
                      <img
                        key={index}
                        src={`https://okr.luvd.co.kr/api/common/image/${item.image_name}`}
                        // src={`http://localhost:8020/image_stable_diffusion/${item.image_name}`}
                        // src={`https://localhost:8020/image_stable_diffusion/st_0e0d455b-2368-4e93-b7b9-53b3d7997c6c.png`}
                        alt="Generated"
                        style={{ width: "80px", height: "auto" }}
                      />
                      <button className="select_image" onClick={() => saveImageLocally(item.image_name)}>
                        저장하기
                      </button>
                    </div>
                  </Tuple>
                </>
              ))
            ) : (
              <></>
            )}
            <div></div>
          </>
        </ImageGeneratorContainer>
      </>
    );
  })
);

const Tuple = styled.div`
  .separated_paragraph {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #c8d9f7;
    margin-top: 10px;
  }

  .created_images_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  .select_image {
    border-radius: 8px;
    width: 100px;
    height: 30px;
    margin-top: 5px;
    background-color: lightgrey;
    text-align: center;
    line-height: 30px;
  }
`;

const ImageGeneratorContainer = styled.div`
  background: #ffffff;
  height: 350px;
  margin-top: 20px;
  padding: 20px;
  overflow: auto;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  box-sizing: border-box;

  h1 {
    font-size: 15px;
    font-weight: 700;
  }

  p,
  span {
    font-size: 13px;
    line-height: 17px;
  }

  .image_generate_btn {
    margin-left: 5px;
    border-radius: 4px;
    padding: 8px;
    display: inline-block;
    cursor: pointer;
    background-color: #42415c;
    color: white;
  }

  .created_images_container {
    margin: 10px auto;
    border-radius: 4px;
    border: 1px solid #e4e4e4;
    box-sizing: border-box;
  }

  .direct_input_box {
    width: 400px;
    height: 30px;

    > input {
      all: unset;
      font-size: 12px;
    }
  }
`;

export default ImageDirectGeneratorBoard;
